<template>

<app-view-sheet-field :is-sticky="isSticky" :field="field" :filter="filter">

    {{ item.play.location }}

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky']

}

</script>

<style scoped>

</style>